import React from 'react'
import { ConciergeStepInfo } from '../../utils/types'
import ConciergeStep from './ConciergeStep'
import '../../styles/WelcomeSection/ConciergeSteps.scss'

const conciergeSteps: ConciergeStepInfo[] = [
  {
    heading: 'Look Forward to Our Phone Call',
    bodyText:
            'Expect a phone call soon from the SmartAsset team to connect you with an advisor match in real-time.'
  },
  {
    heading: 'Review Your Financial Advisor Matches',
    bodyText:
            'Check out your advisor matches below to get an idea of their certifications and experience.'
  },
  {
    heading: 'Find a Financial Advisor that Works for You',
    bodyText:
            "You'll have the opportunity to chat with each of your matches for free, no commitment needed."
  }
]

const ConciergeStepList = () => {
  return (
        <div className="concierge_steps">
            {conciergeSteps.map((stepInfo, i) => (
                <ConciergeStep key={i} conciergeStepInfo={stepInfo} />
            ))}
        </div>
  )
}

export default ConciergeStepList
